import {
  type DeviceSecurityResponse,
  makeTypeGuardByProperty,
} from '@ipfabric/utils';
import type { HostIdentifier } from 'model/HostIdentifier';

export type SecuritySchemaDirectDataSource = {
  data: DeviceSecurityResponse;
};

export const isSecuritySchemaDirectDataSource = makeTypeGuardByProperty<
  SecuritySchemaDataSource,
  SecuritySchemaDirectDataSource
>('data');

export type SecuritySchemaApiDataSource = {
  hostIdentifier: HostIdentifier;
};

export const isSecuritySchemaApiDataSource = makeTypeGuardByProperty<
  SecuritySchemaDataSource,
  SecuritySchemaApiDataSource
>('hostIdentifier');

export type SecuritySchemaDataSource =
  | SecuritySchemaDirectDataSource
  | SecuritySchemaApiDataSource;
